import { MerchantGroupQueryParamName } from "src/merchantgroups/objects/MerchantGroupQueryParam";
import { useQueryParams } from "src/shared/hooks/queryparams/useQueryParams";

export const useMerchantGroupQueryParam = () => {
  const queryParams = useQueryParams();
  return queryParams.get(MerchantGroupQueryParamName) ?? undefined;
};
